import { render, staticRenderFns } from "./TablaNoSeriadaTodos.vue?vue&type=template&id=6d67cdb7&"
import script from "./TablaNoSeriadaTodos.vue?vue&type=script&lang=ts&"
export * from "./TablaNoSeriadaTodos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6d67cdb7', component.options)
    } else {
      api.reload('6d67cdb7', component.options)
    }
    module.hot.accept("./TablaNoSeriadaTodos.vue?vue&type=template&id=6d67cdb7&", function () {
      api.rerender('6d67cdb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MovimientoDispositivos/TablaNoSeriadaTodos.vue"
export default component.exports